import React from 'react';
import { Row } from 'antd';
import { useHistory } from 'react-router-dom';
import { Label } from 'components/common/styles';
import {
  //GreenColor,
  SmartBackButton,
  //SmartFormLabel,
  //SmartScanner,
  SmartSpace,
  //SmartSpin,
} from 'components/Sales/Smart/SmartComponent';
import { poControlStatus } from 'constants/enums';

type Props = {
  po: StringKAnyVPair;
  setLockScreen?: Function;
};

const PoInfo = (props: Props) => {
  const { useState } = React;
  const [inited, setInited] = useState(false);
  const history = useHistory();

  // eslint-disable-next-line
  const getPoLines = async (id: string, warehouseCode: string, update?: boolean) => {
  };

  React.useEffect(() => {
    if (!inited) {
      setInited(true);
    }
  }, [inited]);

  return (<>
    <SmartSpace>
      <Row>
        <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Current PO#</Label>
        <Label theme={{fontSize: '1.2em'}}>{props.po.poNumber || ''}</Label>
      </Row>
      <Row>
        <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO Warehouse</Label>
        <Label theme={{fontSize: '1.2em'}}>{props.po.warehouseCode || ''}</Label>
      </Row>
      <Row>
        <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Control Status</Label>
        <Label theme={{fontSize: '1.2em'}}>{poControlStatus[`${props.po.controlStatus}`] || ''}</Label>
      </Row>
      <Row>
        <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Container #</Label>
        <Label theme={{fontSize: '1.2em'}}>{props.po.container || ''}</Label>
      </Row>
      <Row>
        <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Supplier</Label>
        <Label theme={{fontSize: '1.2em'}}>{props.po.vendorName || ''}</Label>
      </Row>
    </SmartSpace>
    <SmartSpace>
      <SmartBackButton
        onClick={() => history.goBack()}
      />
    </SmartSpace>
  </>);
};

export default PoInfo;
